import { DatePicker } from "@material-ui/pickers";
import { required, SelectInput, useAuthenticated } from "react-admin";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { RouteComponentProps } from "react-router-dom";
import { ReportForm } from "../common/ReportForm";
import { RaDriverPicker } from "../../common/form/RaDriverPicker";
import { useCallback } from "react";
import { startOfDay } from "date-fns";
import { DailyLogsDownloadFormat } from "../../../common/data/service-proxies";

interface Props extends RouteComponentProps {}

interface IDailyLogsReportData {
  dateFrom: Date;
  dateTo: Date;
  driverId: number;
  downloadFormat: DailyLogsDownloadFormat;
}

export const DailyLogsReport = (props: Props) => {
  useAuthenticated();

  const transformDates = useCallback((input: any) => {
    const data = input as IDailyLogsReportData;
    data.dateFrom = startOfDay(data.dateFrom);
    data.dateTo = startOfDay(data.dateTo);
    return data;
  }, []);

  return (
    <ReportForm
      transform={transformDates}
      reportName="daily-logs-report"
      {...props}
      title="resources.reports.dailyLogs.name"
      submitMethod={(x) => x.reportDailylogsreportPost}
    >
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateFrom"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateTo"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <RaDriverPicker source="driverId" validate={required()} />
      <SelectInput
        label="Report format"
        validate={required()}
        source="downloadFormat"
        alwaysOn
        choices={[
          { id: DailyLogsDownloadFormat.Zip, name: "Zip" },
          { id: DailyLogsDownloadFormat.MergedPdf, name: "Merged Pdf" },
        ]}
      />
    </ReportForm>
  );
};
